export default __webpack_public_path__ + "static/media/Christie_Hartbarger_AHV_In_Moms_We_Trust.96bb62be.jpg";